import { Button } from "@material-ui/core"
import React from "react"
import clsx from "clsx"

import useStyles from "./DefaultButtonStyles"

const DefaultButton = ({ children, className, stylization, startIcon, loading, ...props }) => {
  const classes = useStyles()

  const buttonClass = clsx(
    {
      [classes.buttonPrimary]: stylization === "primary",
      [classes.buttonSecondary]: stylization === "secondary",
      [classes.buttonTertiary]: stylization === "tertiary",
      [classes.buttonDanger]: stylization === "danger",
      [classes.buttonText]: stylization === "text",
      [classes.buttonContact]: stylization === "contact",
    },
    className,
  )

  return (
    <Button className={buttonClass} startIcon={startIcon} {...props}>
      {children}
    </Button>
  )
}

export default DefaultButton
